import store from '@/store'

export function getTaskStatusText (task_status) {
  switch (task_status) {
    case 0:
      return '未标注'
    case 1:
      return '已标注'
    case 2:
      return '已确认'
    case 3:
      return '已完成'
    default:
      return '未分配'
  }
}

export function getLabelStatusText (label_status) {
  switch (label_status) {
    case '0':
      return '未标注'
    case '1':
      return '未确认'
    default:
      return '未标注'
  }
}

export function getDiagnoseStatusText (diagnose_status) {
  switch (diagnose_status) {
    case '0':
      return '未诊断'
    case '1':
      return '已诊断'
    default:
      return '未诊断'
  }
}

export function getHospitalText (hospitalId) {
  const hospitals = store.getters.projectHospitals
  for (var i = 1; i < hospitals.length; i++) {
    if (hospitals[i].key == hospitalId) return hospitals[i].value
  }
  return ''
}

export function getUserUid (user_name) {
  const users = store.getters.projectUsers
  for (var i = 1; i < users.length; i++) {
    if (users[i].user_name == user_name) return users[i].uid
  }
  return ''
}

export function getGenderText (gender) {
  switch (gender) {
    case 0 :
      return '男'
    case 1:
      return '女'
    default:
      return '未知'
  }
}

export function getUserStatusToText (userStatus) {
  switch (userStatus) {
    case 0 :
      return '禁用'
    case 1:
      return '可用'
  }
}

export function getLabelTypeToText (labelType) {
  switch (labelType) {
    case 0 :
      return '未配置'
    case 1 :
      return '全局标注'
    case 2 :
      return '局部标注'
    case 3 :
      return '全部'
  }
}

export function getUserRole (userRole) {
  switch (userRole) {
    case 0 :
      return '测试用户'
    case 1:
      return '管理员'
    case 2:
      return '普通用户'
  }
}

export function getPermissionText (permission) {
  //
  switch (permission) {
    case 'user_label':
      return '标注'
    case 'user_collect':
      return '采集'
    case 'user_diagnose':
      return '诊断'
    case 'admin_item':
      return '项目'
    case 'admin_data':
      return '数据'
    default:
      return ''
  }
}

export const DEFAULT_IMAGE = 'http://img.58cdn.com.cn/dist/jxedt/pc/products/jxregister/images/no_data.png'
export const INFINITY = 64000
